<template>
  <div class="contact-box">
    <div class="contact-top" :class="{ 'not-show': !showGoTop }" @click="goTop">
      <img width="16" height="16" src="@/assets/imgs/arrow-up-large.png" />
    </div>
    <div v-popover:contactPopover class="contact-service popover-icon-content">
      <i class="iconfont icon-kefu"></i>
    </div>
    <el-popover
      ref="contactPopover"
      placement="left"
      trigger="hover"
      popper-class="popover-radius2"
    >
      <div class="contact-popover">
        <div
          style="
            font-size: 14px;
            color: #212a40;
            display: flex;
            align-items: end;
          "
        >
          客服热线<b class="contact-tel">400-060-0160</b>
        </div>
        <div style="margin-top: 8px; font-size: 12px; color: #6d7383">
          周一至周五：9:00~18:00
        </div>
      </div>
    </el-popover>
    <div
      v-popover:onlinePopover
      class="online-service popover-icon-content"
      @click="autoServer"
    >
      <i class="iconfont icon-zaixiankefu"></i>
    </div>
    <el-popover
      ref="onlinePopover"
      placement="left"
      trigger="hover"
      popper-class="popover-radius2"
    >
      <div class="contact-popover">
        <div style="font-size: 14px; color: #212a40">
          <span class="contact-link" @click="autoServer">在线客服</span
          ><span style="font-size: 12px; color: #6d7383; margin-left: 10px"
            >周一至周五：9:00~18:00</span
          >
        </div>
      </div>
    </el-popover>
    <div
      v-popover:oncodePopover
      class="online-service popover-icon-content"
      @click="autoServer"
    >
      <i class="iconfont icon-erweima3"></i>
    </div>
    <el-popover
      ref="oncodePopover"
      placement="left"
      trigger="hover"
      popper-class="popover-radius2"
    >
      <div class="contact-popover">
        <div class="erweima-box">
          <div class="contact-btoom">
            <img
              width="128"
              height="128"
              background-size="100% 100%"
              background-repeat="no-repeat"
              background-position="0 0"
              src="@/assets/imgs/sqrcode.png"
            />
          </div>
          <span>扫码反馈您的建议</span>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { onlineServiceUrl, onlineServiceStr } from "@domain";
import { mapGetters } from "vuex";
import { Base64 } from "js-base64";

export default {
  name: "contact",
  data() {
    return {
      scrollTimer: null,
      showGoTop: false,
      mainClass: ".main-page-scroll", // 外层滚动条
      innerClass: ".page-content", // 内层滚动条
      type: "2", // type 客户类型：客户域（0主客户|子客户为空）|2 渠道客户（主账号2，子账号0）
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  computed: {
    // 从store中获取当前用户和主账户
    ...mapGetters(["userInfo", "mainUserInfo"]),
  },
  watch: {
    "$route.fullPath"(newVal, oldVal) {
      this.showGoTop = false;
    },
  },
  methods: {
    // 智能客服
    autoServer() {
      if (this.userInfo) {
        let loginName = this.userInfo.userName || "";
        let userCode = this.userInfo.userCode || "";
        // type 客户类型：客户域（0主客户|子客户为1）|2 渠道客户（主账号2，子账号为3）
        if (this.userInfo.isMaster) {
          this.type = "2";
        } else {
          this.type = "3";
        }
        let platform = "BECP"; // 2020.9.9,屈：门户/客户/渠道/工单，都是一致的，写死
        let userInfoParams = {
          userCode: userCode,
          loginName: loginName,
          customerType: this.type,
        };
        let usrInfoKey = JSON.stringify(userInfoParams);
        let usrInfoKeyStr = Base64.encode(usrInfoKey);
        let sysNum = onlineServiceStr; // 放在url-conf.js中，目前仅两个环境：1.生产，2.其他
        let url = `${onlineServiceUrl}/chat/pc/index.html?sysNum=${sysNum}&params=${usrInfoKeyStr}&platform=${platform}`;
        window.open(url, "_blank");
      }
    },
    // 绑定滚动条
    handleScroll(event) {
      let ev = event || window.event;
      if (
        !ev.target.classList ||
        !ev.target.classList.contains("page-content")
      ) {
        return;
      }
      let docHeight = document.body.offsetHeight;
      let contentHeight = docHeight - 120;
      if (ev.target.scrollTop > contentHeight) {
        this.showGoTop = true;
      } else {
        this.showGoTop = false;
      }
    },
    goTop() {
      // 外层滚动条
      let mainScrollTop = document.querySelector(this.mainClass)
        ? document.querySelector(this.mainClass).scrollTop
        : 0;
      // 内层滚动条
      let innerScrollTop = document.querySelector(this.innerClass)
        ? document.querySelector(this.innerClass).scrollTop
        : 0;
      if (mainScrollTop > 0) {
        document.querySelector(this.mainClass).scrollTop = 0;
      }
      if (innerScrollTop > 0 && !this.scrollTimer) {
        this.scrollTimer = setInterval(() => {
          document.querySelector(this.innerClass).scrollTop = Math.max(
            document.querySelector(this.innerClass).scrollTop - 20,
            0
          );
          if (document.querySelector(this.innerClass).scrollTop === 0) {
            clearInterval(this.scrollTimer);
            this.scrollTimer = null;
          }
        }, 10);
      }
    },
  },
  destroyed() {
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer);
      this.scrollTimer = null;
    }
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.contact-box {
  position: fixed;
  width: 30px;
  right: 4px;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  background-color: #3369ff;
  box-shadow: 0 2px 6px 0 rgba(33, 76, 217, 0.26);
  .contact-top,
  .contact-service,
  .online-service {
    border-radius: 15px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    height: 30px;
    transition: 0.5s;
    .iconfont {
      color: #fff;
      font-size: 16px;
      &.icon-arrow-up-large {
        font-size: 11px;
      }
    }
    &:hover {
      background-color: #214cd9;
    }
  }
  .popover-icon-content {
    &.focusing {
      outline: none !important;
    }
  }
  .contact-top {
    overflow: hidden;
    height: 30px;
    margin-bottom: 10px;
    &.not-show {
      height: 0;
      margin-bottom: 0;
    }
  }
}
.contact-link {
  cursor: pointer;
}
.contact-popover {
  white-space: nowrap;
  padding: 10px 16px;
  .contact-tel {
    font-family: "Microsoft YaHei";
    font-size: 16px;
    padding-left: 10px;
  }
}
.erweima-box {
  font-size: 14px;
  color: #212a40;
  text-align: center;
  span {
    display: inline-block;
    margin-top: 8px;
    margin-bottom: 2px;
  }
}
</style>
<style lang="scss">
.popover-radius2 {
  border-radius: 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue